import { IPromotionState } from './types';

export const defaultState: IPromotionState = {
  banner: { promotionTypeChangeReason: null },
  toggle: {
    checked: false,
    disabled: false,
    changedByUser: false,
  },
  restriction: {
    isAllowed: true,
    restrictionType: undefined,
  },
  auctionBet: {
    minBet: 0,
    maxBet: 10000,
    value: 0,
    step: 10,
    previousBets: [],
    nextBets: [],
    available: false,
    token: '',
    restrictionType: undefined,
  },
  duration: {
    durations: [],
    defaultDuration: 1,
  },
  services: [],
  competitors: [],
  isChangedByUser: false,
};

export const defaultPromotionDuration = 1;
